import WsProvider from './provider/WSProvider';

var serviceName = 'webservis';
var moduleName = 'arsatahsis';

var arsaService = {
    path: WsProvider.apiPath + 'belge/arsatahsis/arsa/',
    musteriListele(cariDurumu, baslangic = 0, limit = 10000) {
        var userDataDemirag = localStorage.getItem('userDataDemirag');
        var param = {
            token: userDataDemirag,
            'data[durum]': cariDurumu,
            'data[baslangic]': baslangic,
            'data[limit]': limit,
            serviceName: 'musteri',
            methodName: 'musteriListesi',
        };
        var result = new Promise(function (resolve, reject) {
            WsProvider.ajaxPost(serviceName, param)
                .then((response) => {
                    resolve(response);
                })
                .catch((error) => {
                    reject(error);
                });
        });

        return result;
    },
    arsaDetay(musteriID, projeID) {
        var userDataDemirag = localStorage.getItem('userDataDemirag');
        var param = {
            token: userDataDemirag,
            'data[musteriID]': musteriID,
            'data[projeID]': projeID,
            serviceName: 'arsaTahsis',
            methodName: 'ArsaDetay',
        };
        var result = new Promise(function (resolve, reject) {
            WsProvider.ajaxPost(serviceName, param)
                .then((response) => {
                    resolve(response);
                })
                .catch((error) => {
                    reject(error);
                });
        });
        return result;
    },
    createArsaFiles({musteriID, projeID, images, baslik, belge, updateID}) {
        try {
            var token = localStorage.getItem('userDataDemirag');
            var param = {
                token,
                [`data[${!updateID ? 'musteriID' : 'musteriID'}]`]: !updateID ? musteriID : musteriID,
                [`data[${!updateID ? 'projeID' : 'arsaID'}]`]: !updateID ? projeID : updateID,
                'data[baslik]': baslik,
                'belge': belge,
                methodName: !updateID ? 'ArsaEkle' : 'ArsaGuncelle',
                serviceName: moduleName,
            };
            if (images !== undefined && typeof images.forEach === 'function') {
                images.forEach((item, index) => (param[`resim[${index}]`] = item));
            }
            var result = new Promise(function (resolve, reject) {
                WsProvider.ajaxPost(serviceName, param)
                    .then(response => {
                        resolve(response);
                    })
                    .catch(error => {
                        reject(error);
                    });
            });
            return result;
        } catch (error) {
            console.log(error);
        }
    },
    arsaListele(arsaDurumu, baslangic = 0, limit = 10000) {
        var userDataDemirag = localStorage.getItem('userDataDemirag');
        var param = {
            token: userDataDemirag,
            'data[durum]': arsaDurumu,
            'data[baslangic]': baslangic,
            'data[limit]': limit,
            serviceName: moduleName,
            methodName: 'ArsaListele',
        };
        var result = new Promise(function (resolve, reject) {
            WsProvider.ajaxPost(serviceName, param)
                .then((response) => {
                    resolve(response);
                })
                .catch((error) => {
                    reject(error);
                });
        });
        return result;
    },
    arsaArama(musteriAdi, projeAdi, arsaDurumu, baslangic, limit) {
        var userDataDemirag = localStorage.getItem('userDataDemirag');
        var param = {
            token: userDataDemirag,
            'data[musteriAdi]': musteriAdi,
            'data[projeAdi]': projeAdi,
            'data[arsaDurumu]': arsaDurumu,
            'data[baslangic]': baslangic,
            'data[limit]': limit,
            serviceName: moduleName,
            methodName: 'ArsaAra',
        };
        var result = new Promise(function (resolve, reject) {
            WsProvider.ajaxPost(serviceName, param)
                .then((response) => {
                    resolve(response);
                })
                .catch((error) => {
                    reject(error);
                });
        });
        return result;
    },
    arsaTamamenSil(arsaTahsisID) {
        var userDataDemirag = localStorage.getItem('userDataDemirag');
        var param = {
            token: userDataDemirag,
            'data[arsaTahsisID]': arsaTahsisID,
            serviceName: moduleName,
            methodName: 'ArsaTamamenSil',
        };
        var result = new Promise(function (resolve, reject) {
            WsProvider.ajaxPost(serviceName, param)
                .then((response) => {
                    resolve(response);
                })
                .catch((error) => {
                    reject(error);
                });
        });
        return result;
    },
    arsaDosyaSil(id) {
        var token = localStorage.getItem('userDataDemirag');
        var param = {
            token,
            'data[arsaTahsisID]': id,
            methodName: 'ArsaSil',
            serviceName: moduleName,
        };
        var result = new Promise(function (resolve, reject) {
            WsProvider.ajaxPost(serviceName, param)
                .then(response => {
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                });
        });
        return result;
    },
    arsaDurumDegis(id, durum) {
        var token = localStorage.getItem('userDataDemirag');
        var param = {
            token,
            'data[id]': id,
            'data[durum]': durum,
            methodName: 'DurumDegistir',
            serviceName: moduleName,
        };
        var result = new Promise(function (resolve, reject) {
            WsProvider.ajaxPost(serviceName, param)
                .then(response => {
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                });
        });
        return result;
    },
    sunucuDosyaEkle({musteriID, projeID, baslik, dosyaID}) {
        var token = localStorage.getItem('userDataDemirag');
        var param = {
            token,
            [`data[musteriID]`]: musteriID,
            [`data[projeID]`]: projeID,
            'data[baslik]': baslik,
            'data[dosyaID]': dosyaID,
            methodName: 'dosyaEkle',
            serviceName: moduleName,
        };
        var result = new Promise(function (resolve, reject) {
            WsProvider.ajaxPost(serviceName, param)
                .then(response => {
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                });
        });
        return result;
    },
};

export default arsaService;
